<div [ngClass]="{ block: displayAsBlock(), 'inline-block': !displayAsBlock() }" class="relative">
  <input
    (focus)="onFocus($event)"
    (blur)="onBlur()"
    (input)="onInput($event)"
    (click)="onClick($event)"
    (keydown)="onKeyDown($event)"
    [class.cursor-pointer]="!disabled()"
    [class.border-gray]="disabled()"
    [(ngModel)]="currentInputValue"
    [class.rounded-b-xl]="!isOpen()"
    class="h-7 w-full rounded-t-xl border bg-gray-light px-3 py-5 focus:outline-none" />
  @if (isOpen()) {
    <div
      [ngClass]="{
        'left-1/2 -translate-x-1/2': dropdownPosition() === 'CENTER',
        'right-0': dropdownPosition() === 'RIGHT',
      }"
      class="absolute z-50 -mt-px w-max min-w-full overflow-hidden rounded-b-xl border bg-gray-light">
      <ul class="flex max-h-[258px] flex-col overflow-y-auto desk:max-h-[344px]">
        @for (option of displayedOptions(); track option.key) {
          <li
            (mousedown)="$event.preventDefault()"
            (click)="select(option)"
            class="flex cursor-pointer justify-between p-3 last:rounded-b-xl hover:bg-gray/25">
            <span>{{ option.label }}</span>
            @if (selected()?.key === option.key) {
              <app-svg [height]="24" [width]="24" src="assets/icons/check.svg" />
            }
          </li>
        }
      </ul>
    </div>
  }
</div>
